var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.993,
    height: 8.99,
    viewBox: "0 0 6.993 8.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M8,12.491a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V6.5H8ZM9.228,8.935l.7-.7L11,9.29l1.059-1.059.7.7L11.7,9.994l1.059,1.059-.7.7L11,10.7,9.937,11.757l-.7-.7,1.059-1.059ZM12.745,5l-.5-.5h-2.5l-.5.5H7.5V6h6.993V5Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#545454"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilter);
export default __webpack_public_path__ + "static/media/Delete-Filter.228ae71fb221af86a3b92e55cf2dc7e5.svg";
export { ForwardRef as ReactComponent };